import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import useTranslation from '@hooks/i18n/useTranslation.tsx';
import LocalityList from '@app/pages/customer/LocalityList/LocalityList.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';

interface ComponentProps {
}

const LocalityListPage: React.FC<ComponentProps> = () => {
  const { tr } = useTranslation();
  return (
    <>
      <ResponsiveLayout title={tr(`index.localityList`, `Locality list`)}>
        <LocalityList />
      </ResponsiveLayout>
    </>
  );
};

export default withAuthenticationRequired(LocalityListPage);
